var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonebook3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#374DA0",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 5C9.76348 5 9.15303 5.25286 8.70294 5.70294C8.25286 6.15303 8 6.76348 8 7.4V21.8C8 22.4365 8.25286 23.047 8.70294 23.4971C9.15303 23.9471 9.76348 24.2 10.4 24.2H21.8C21.9591 24.2 22.1117 24.1368 22.2243 24.0243C22.3368 23.9117 22.4 23.7591 22.4 23.6C22.4 23.4409 22.3368 23.2883 22.2243 23.1757C22.1117 23.0632 21.9591 23 21.8 23H10.4C10.0817 23 9.77652 22.8736 9.55147 22.6485C9.32643 22.4235 9.2 22.1183 9.2 21.8H21.2C21.5183 21.8 21.8235 21.6736 22.0485 21.4485C22.2736 21.2235 22.4 20.9183 22.4 20.6V7.4C22.4 6.76348 22.1471 6.15303 21.6971 5.70294C21.247 5.25286 20.6365 5 20 5H10.4ZM17 11.6C17 12.0774 16.8104 12.5352 16.4728 12.8728C16.1352 13.2104 15.6774 13.4 15.2 13.4C14.7226 13.4 14.2648 13.2104 13.9272 12.8728C13.5896 12.5352 13.4 12.0774 13.4 11.6C13.4 11.1226 13.5896 10.6648 13.9272 10.3272C14.2648 9.98964 14.7226 9.8 15.2 9.8C15.6774 9.8 16.1352 9.98964 16.4728 10.3272C16.8104 10.6648 17 11.1226 17 11.6ZM11.6 15.5C11.6 15.2613 11.6948 15.0324 11.8636 14.8636C12.0324 14.6948 12.2613 14.6 12.5 14.6H17.9C18.1387 14.6 18.3676 14.6948 18.5364 14.8636C18.7052 15.0324 18.8 15.2613 18.8 15.5V15.8C18.8 16.4365 18.5471 17.047 18.0971 17.4971C17.647 17.9471 17.0365 18.2 16.4 18.2H14C13.3635 18.2 12.753 17.9471 12.3029 17.4971C11.8529 17.047 11.6 16.4365 11.6 15.8V15.5Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonebook3);
export default __webpack_public_path__ + "static/media/phonebook3.cad2f235ec31f730e7fdaa721f6efc89.svg";
export { ForwardRef as ReactComponent };